import {
  LegacyAddToCartParams as CartParams,
  CartUpsell,
  FullLegacyAddToCartParams,
  ItemType,
} from 'types/cart.types';
import { format } from 'date-fns';
import { isNotUndefined } from 'utils/is-not-undefined';
import { pickBy } from 'utils/pick-by';

export function fillLegacyCartDefaultParams(
  cart: CartParams,
): FullLegacyAddToCartParams {
  return {
    ...(pickBy(
      {
        OrderType: cart.OrderType,
        FreeProducts: [
          {
            Quantity: 0,
            ArrangementID: 0,
            ArrangementProductID: 0,
            ArrangementPromotionID: 0,
          },
        ],
        AddonItems: [
          pickBy(
            {
              AddOnType: undefined,
              CYOA: undefined,
              DefaultSleeve: undefined,
              ImagePrefixSleeve: undefined,
              ItemType: ItemType.NotSpecified,
              Numbers: undefined,
              OptionText: '',
              ParentProductID: undefined,
              Price: '0',
              PrintibleCard: '',
              PrintibleCardResponse: '',
              ProductID: 0,
              ProductImagePath: undefined,
              ProductName: undefined,
              Quantity: 0,
              Sleeve: undefined,
              Years: undefined,
            },
            isNotUndefined,
          ) as CartUpsell,
        ],
        ArrangementOption: '',
        ArrangementOptionID: 0,
        CallRecipient: null,
        CarInfo: '',
        Catering: false,
        ConfigDeliveryDate: format(new Date(), 'M/dd/yyyy'),
        ConfigDeliveryFeeCharges: '0',
        DeliveryFeeDetailID: 0,
        DeliveryOrPickupInstructions: '',
        FlexDiscount: 0,
        FlexFromDate: '01/01/0001',
        FlexOptionID: 0,
        FlexToDate: '01/01/0001',
        FulfillmentTimeFrom: '1/1/0001 12:00:00 AM',
        FulfillmentTimeTo: '1/1/0001 12:00:00 AM',
        IsCurbSide: false,
        OccassionRec: false,
        OccassionRecDate: '1/1/0001 12:00:00 AM',
        Pickup7Minute: false,
        UpgradeItems: [
          pickBy(
            {
              AddOnType: undefined,
              CYOA: undefined,
              DefaultSleeve: undefined,
              ImagePrefixSleeve: undefined,
              ItemType: ItemType.NotSpecified,
              Numbers: undefined,
              OptionText: '',
              ParentProductID: undefined,
              Price: '0',
              PrintibleCard: '',
              PrintibleCardResponse: '',
              ProductID: 0,
              ProductImagePath: undefined,
              ProductName: undefined,
              Quantity: 0,
              Sleeve: undefined,
              Years: undefined,
            },
            isNotUndefined,
          ) as CartUpsell,
        ],
        skipOnDelivery: '0',
      },
      isNotUndefined,
    ) as Required<FullLegacyAddToCartParams>),
    ...cart,
  };
}
